export default "__VITE_ASSET__ChpDtSKT__"